import axiosInstance from "../axiosInterceptor";

export async function getCourseNameByUniversitySlug(slug, search = "") {
    const response = await axiosInstance.get(
        `admin/course/getCourseNameByUniversitySlug/${slug}`,
        { params: { search } } 
    );
    return response?.data;
}